import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fcdabeb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-switch-container" }
const _hoisted_2 = { class: "progress-bar-container" }
const _hoisted_3 = { class: "owner-page" }
const _hoisted_4 = { class: "wizard-page" }
const _hoisted_5 = { class: "wizard-page" }
const _hoisted_6 = { class: "tenant-switch-footer-container" }
const _hoisted_7 = { class: "button-holder" }
const _hoisted_8 = { class: "steps" }

import { computed, inject, ref, watch } from "vue";
import ModalBase from "@/components/ui/modals/modal-base.vue";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import displayErrorMessage from "@/utils/ErrorHandling";
import { getErrorMessage } from "bright-logic-core/src/errors";
import TenantSwitchProgress from "@/components/switches/tenant-switch-progress.vue";
import { Properties } from "acquaint-api/models/Properties";
import DxMultiView from "devextreme-vue/multi-view";
import { QuestionsWizardData } from "@/types/wizard/question-wizard-data";
import ContactLookup from "@/components/ui/lookup/contact-lookup.vue";
import { DxButton } from "devextreme-vue";
import ContactModal from "@/components/contacts/record/contact-modal.vue";
import EditAddress from "@/components/ui/address/edit-address.vue";
import CurrencyInput from "@/components/ui/inputs/currency-input.vue";
import BedroomsSelect from "@/components/ui/dropdowns/bedrooms-select.vue";
import SystemCodeSingleSelect from "@/components/ui/system-codes/system-code-single-select.vue";
import { CodeType } from "acquaint-api/constants/CodeType";
import LookupSingleSelect from "@/components/ui/lookup/lookup-single-select.vue";
import { LookupTableSource } from "acquaint-api/constants/LookupTableSource";
import { Address } from "@/types/generic/Address";
import { EditAddressValidation } from "@/types/validation/EditAddressValidation";
import { ValidatedEvent } from "devextreme/ui/validator";
import { PropertiesValidation } from "acquaint-api/validation/PropertiesValidation";
import { Contacts } from "acquaint-api/models/Contacts";
import { PropertyCategory } from "acquaint-api/constants/PropertyCategory";
import { ContactFindResult } from "@/types/find/contacts/ContactFindResult";
import { PropertyStatus } from "acquaint-api/constants/PropertyStatus";
import { displayQuestionAlert } from "@/alerts/questionAlert";
import { useContactTypeConfigurationStore } from "@/stores/ContactTypeConfigurationStore";
import { SystemContactTypes } from "@/enums/contacts/SystemContactTypes";
import { DisplayCompanyAlert } from "@/utils/DisplayCompanyAlert";
import SelectCompanyModal from "./select-company-modal.vue";
import { IDDescriptionPair } from "@/types/generic/IDDescriptionPair";
import { AcquaintApiNextClient } from "@/services/AcquaintApiNextClient";


export default /*#__PURE__*/_defineComponent({
  __name: 'new-property-wizard',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /**
   * The unique identifier for the ower.
   * @type {number}
   * @required
   */
  ownerId: {
    type: Number,
    default: 0,
  },
  /**
   * A boolean that determines whether the contact lookup is read only.
   * @type {boolean}
   * @default false
   */
  contactLookupReadOnly: {
    type: Boolean,
    default: false,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
  "modalClosed",
],
  setup(__props, { emit }) {

const props = __props;





const apiNextClient = inject("AcquaintApiNextClient") as AcquaintApiNextClient;
const apiClient = inject("AcquaintApiClient") as AcquaintApiClient;
const displayCancelConfirmationModal = ref(false);
const keepingModalOpening = ref(false);
const saving = ref(false);
const selectedIndex = ref(0);
// These are the progress bar statuses, if a bar's status is 0, the bar is has no progress and
// when it is 1, the bar has been 100% completed.
const stageTwo = ref(0);
const stageThree = ref(0);
const editableData = ref<Properties>();
const originalData = ref<Properties>();
const displayNewContactModal = ref(false);
const isContactEntered = ref(false);
const selectedContact = ref<Contacts>();
const ownerDetails = ref<Contacts>();
const displayCompaniesModal = ref(false);
const contactTypeConfigurationStore = useContactTypeConfigurationStore();
const companies = ref<IDDescriptionPair[]>([]);
const addressModel = ref<Address>({
  countryCode: 0,
  postCode: "",
  propertyName: "",
  street: "",
  locality: "",
  town: "",
  region: "",
  country: "",
});

const addressValidation = ref<EditAddressValidation>({
  propertyName: PropertiesValidation.PropertyName,
  street: PropertiesValidation.Street,
  locality: PropertiesValidation.Locality,
  town: PropertiesValidation.Town,
  region: PropertiesValidation.Region,
  postcode: PropertiesValidation.Postcode,
});

// Each page must be assigned a template name for it to appear
const pages = ref<QuestionsWizardData[]>([
  {
    template: "owner",
  },
  {
    template: "address",
  },
  {
    template: "mainDetails",
  },
]);

const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

watch(
  () => selectedIndex.value,
  () => {
    switch (selectedIndex.value) {
      case 0: {
        stageTwo.value = 0;
        stageThree.value = 0;
        break;
      }
      case 1: {
        stageTwo.value = 1;
        stageThree.value = 0;
        break;
      }
      case 2: {
        triggerCompanyModalToOpen(editableData.value?.category ?? 0);
        stageTwo.value = 1;
        stageThree.value = 1;
        break;
      }
    }
  },
);

watch(
  () => showModal.value,
  async () => {
    if (!showModal.value || keepingModalOpening.value) {
      return;
    }

    // We must reset
    stageTwo.value = 0;
    stageThree.value = 0;
    selectedIndex.value = 0;
    isContactEntered.value = false;
    selectedContact.value = undefined;
    editableData.value = undefined;

    await fetchDefaultData();

    if (!originalData.value) {
      addressModel.value.countryCode = 0;
      addressModel.value.country = "";
      addressModel.value.propertyName = "";
      addressModel.value.street = "";
      addressModel.value.locality = "";
      addressModel.value.town = "";
      addressModel.value.region = "";
      addressModel.value.postCode = "";
      return;
    }

    addressModel.value.countryCode = originalData.value?.countryCode ?? 0;
    addressModel.value.country = originalData.value?.country ?? "";
    addressModel.value.propertyName = originalData.value?.propertyName ?? "";
    addressModel.value.street = originalData.value?.street ?? "";
    addressModel.value.locality = originalData.value?.locality ?? "";
    addressModel.value.town = originalData.value?.town ?? "";
    addressModel.value.region = originalData.value?.region ?? "";
    addressModel.value.postCode = originalData.value?.postcode ?? "";

    editableData.value = JSON.parse(JSON.stringify(originalData.value));

    if (!props.ownerId) {
      return;
    }

    if (!editableData.value) {
      return;
    }

    editableData.value.contactID = props.ownerId;

    await fetchOwnersDetails();

    const typeOfOwnerType = ownerDetails.value
      ? await contactTypeConfigurationStore.getSystemContactType(
          ownerDetails.value.typeID,
        )
      : -1;

    if (
      typeOfOwnerType != SystemContactTypes.Vendor ||
      (typeOfOwnerType == SystemContactTypes.Vendor &&
        ownerHasNoHomeAddress.value)
    ) {
      return;
    }

    selectedIndex.value++;

    let alert = await displayQuestionAlert(
      "Do you wish to use the Contact’s home address as the address for this property?",
    );

    if (alert.isConfirmed) {
      fillAddressFields();
    }
  },
);

const ownerHasNoHomeAddress = computed(() => {
  return (
    ownerDetails.value?.homeCountry == "" &&
    ownerDetails.value?.homeLocality == "" &&
    ownerDetails.value?.homePostcode == "" &&
    ownerDetails.value?.homeProperty == "" &&
    ownerDetails.value?.homeRegion == "" &&
    ownerDetails.value?.homeStreet == "" &&
    ownerDetails.value?.homeTown == ""
  );
});

const fetchOwnersDetails = async () => {
  try {
    ownerDetails.value = await apiClient.httpGet<Contacts>(
      `database/contacts/${props.ownerId}`,
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    ownerDetails.value = undefined;
  }
};

const fillAddressFields = async () => {
  addressModel.value.countryCode = ownerDetails.value?.homeCountryCode ?? 0;
  addressModel.value.country = ownerDetails.value?.homeCountry ?? "";
  addressModel.value.propertyName = ownerDetails.value?.homeProperty ?? "";
  addressModel.value.street = ownerDetails.value?.homeStreet ?? "";
  addressModel.value.locality = ownerDetails.value?.homeLocality ?? "";
  addressModel.value.town = ownerDetails.value?.homeTown ?? "";
  addressModel.value.region = ownerDetails.value?.homeRegion ?? "";
  addressModel.value.postCode = ownerDetails.value?.homePostcode ?? "";
};

watch(
  () => editableData.value,
  () => {
    displayCancelConfirmationModal.value =
      JSON.stringify(editableData.value) != JSON.stringify(originalData.value);
  },
  { deep: true },
);

const modalClosed = async () => {
  keepingModalOpening.value = false;
  displayCancelConfirmationModal.value = false;
  emit("modalClosed", false);
};

const cancelPromptDenied = () => {
  keepingModalOpening.value = true;
};

const fetchDefaultData = async () => {
  try {
    originalData.value = await apiClient.httpGet(
      `database/properties/defaultmodel`,
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    originalData.value = undefined;
  }
};

const submitData = async () => {
  try {
    editableData.value = await apiClient.httpPost(
      `database/properties`,
      editableData.value,
    );
    return true;
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    return false;
  }
};

const onNavigateClick = (direction: number, e: any) => {
  if (!direction) {
    selectedIndex.value--;
    return;
  }

  if (editableData.value?.contactID == 0) {
    isContactEntered.value = true;
    return;
  }

  isContactEntered.value = false;

  if (selectedIndex.value > 0) {
    const validation: ValidatedEvent = e.validationGroup.validate();

    // Don't continue if user has entered invalid data
    if (!validation.isValid) {
      return;
    }
  }

  if (selectedIndex.value == 2) {
    saveProperty();
    return;
  }

  selectedIndex.value++;
};

const saveProperty = async () => {
  saving.value = true;

  if (!editableData.value) {
    return;
  }

  editableData.value.countryCode = addressModel.value.countryCode;
  editableData.value.country = addressModel.value.country;
  editableData.value.propertyName = addressModel.value.propertyName;
  editableData.value.street = addressModel.value.street;
  editableData.value.locality = addressModel.value.locality;
  editableData.value.town = addressModel.value.town;
  editableData.value.postcode = addressModel.value.postCode;
  editableData.value.region = addressModel.value.region;

  if (await submitData()) {
    displayCancelConfirmationModal.value = false;
    emit("modalClosed", true, editableData.value?.id ?? 0);
    showModal.value = false;
  }
  saving.value = false;
};

const nextSubmitButtonText = computed(() => {
  switch (selectedIndex.value) {
    case 2:
      return "Save";
    default:
      return "Next";
  }
});

const existingContactSelected = (selectedContact: ContactFindResult) => {
  if (!selectedContact) {
    return;
  }

  if (editableData.value) {
    editableData.value.contactID = selectedContact.id;
  }
};

const newContactCreated = (newContactId: number) => {
  if (!newContactId) {
    return;
  }

  if (editableData.value) {
    editableData.value.contactID = newContactId;
  }
};

const buttonValidationGroup = computed(() => {
  switch (selectedIndex.value) {
    case 0:
      return "ownerPage";
    case 1:
      return "address";
    case 2:
      return "mainDetails";
    default:
      return "";
  }
});

const pageNumber = computed(() => {
  let number = selectedIndex.value;
  return number + 1;
});

const fetchCompanies = async (propertyCategory: number) => {
  try {
    companies.value = await apiNextClient.httpGet(
      `companies/lookup/category/${propertyCategory}`,
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    companies.value = [];
  }
};

const triggerCompanyModalToOpen = async (propertyCategory: number) => {
  await fetchCompanies(propertyCategory);

  // We don't want to display the modal if there is only one company, we will just set the company
  // id to the id of the single company.
  if (companies.value.length > 1) {
    displayCompaniesModal.value = await DisplayCompanyAlert();
    return;
  }

  if (!editableData.value) {
    return;
  }

  if (companies.value.length == 1) {
    editableData.value.companyID = companies.value[0].id;
  }
};

watch(
  () => editableData.value?.category,
  (value, oldValue) => {
    if (oldValue == undefined || value == undefined) {
      return;
    }

    triggerCompanyModalToOpen(value);
  },
);

const companySelected = (companyId: number) => {
  if (editableData.value == undefined) {
    return;
  }

  editableData.value.companyID = companyId;
};

const createNewContact = () => {
  displayNewContactModal.value = true;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ModalBase, {
      modelValue: showModal.value,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((showModal).value = $event)),
      title: "Property",
      onCancelPromptDenied: cancelPromptDenied,
      onModalClosed: modalClosed,
      showCloseConfirmationPrompt: displayCancelConfirmationModal.value,
      height: "565px",
      maxHeight: "95vh",
      "help-page": "adding-a-property"
    }, {
      "non-scrollable-content": _withCtx(() => [
        _createElementVNode("section", _hoisted_1, [
          _createElementVNode("section", _hoisted_2, [
            _createVNode(TenantSwitchProgress, {
              index: selectedIndex.value,
              title: "Owner",
              number: 1,
              progress: stageTwo.value
            }, null, 8, ["index", "progress"]),
            _createVNode(TenantSwitchProgress, {
              index: selectedIndex.value,
              title: "Property Address",
              number: 2,
              progress: stageThree.value
            }, null, 8, ["index", "progress"]),
            _createVNode(TenantSwitchProgress, {
              index: selectedIndex.value,
              title: "Main Details",
              number: 3,
              progress: -1
            }, null, 8, ["index"])
          ]),
          (editableData.value)
            ? (_openBlock(), _createBlock(_unref(DxMultiView), {
                key: 0,
                width: "100%",
                "selected-index": selectedIndex.value,
                "onUpdate:selectedIndex": _cache[11] || (_cache[11] = ($event: any) => ((selectedIndex).value = $event)),
                loop: false,
                "animation-enabled": true,
                "data-source": pages.value,
                "swipe-enabled": false
              }, {
                owner: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(ContactLookup, {
                      label: "Select an existing contact",
                      modelValue: editableData.value.contactID,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editableData.value.contactID) = $event)),
                      readOnly: __props.contactLookupReadOnly,
                      isRequired: isContactEntered.value,
                      findNameOnIdChange: true,
                      onContactSelected: existingContactSelected,
                      showClearIcon: true,
                      onNavigateToContact: _cache[1] || (_cache[1] = ($event: any) => (emit('modalClosed', false)))
                    }, null, 8, ["modelValue", "readOnly", "isRequired"]),
                    _createVNode(_unref(DxButton), {
                      text: "New Contact",
                      onClick: createNewContact,
                      disabled: props.contactLookupReadOnly
                    }, null, 8, ["disabled"])
                  ])
                ]),
                address: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(EditAddress, {
                      modelValue: addressModel.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((addressModel).value = $event)),
                      validation: addressValidation.value,
                      validationGroup: buttonValidationGroup.value
                    }, null, 8, ["modelValue", "validation", "validationGroup"])
                  ])
                ]),
                mainDetails: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(SystemCodeSingleSelect, {
                      label: "Category",
                      modelValue: editableData.value.category,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((editableData.value.category) = $event)),
                      "code-type": _unref(CodeType).PropertyCategory
                    }, null, 8, ["modelValue", "code-type"]),
                    (editableData.value.category == _unref(PropertyCategory).ForSale)
                      ? (_openBlock(), _createBlock(SystemCodeSingleSelect, {
                          key: 0,
                          label: "Tenure",
                          modelValue: editableData.value.tenure,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((editableData.value.tenure) = $event)),
                          "code-type": _unref(CodeType).PropertyTenure
                        }, null, 8, ["modelValue", "code-type"]))
                      : _createCommentVNode("", true),
                    _createVNode(SystemCodeSingleSelect, {
                      label: "Status",
                      modelValue: editableData.value.status,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((editableData.value.status) = $event)),
                      "code-type": _unref(CodeType).PropertyStatus,
                      idsToExclude: [
                  _unref(PropertyStatus).Completed,
                  _unref(PropertyStatus).UnderOffer,
                ]
                    }, null, 8, ["modelValue", "code-type", "idsToExclude"]),
                    _createVNode(LookupSingleSelect, {
                      label: "Area",
                      modelValue: editableData.value.propertyAreaID,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((editableData.value.propertyAreaID) = $event)),
                      lookupSource: _unref(LookupTableSource).PropertyAreas
                    }, null, 8, ["modelValue", "lookupSource"]),
                    _createVNode(LookupSingleSelect, {
                      label: "Type",
                      modelValue: editableData.value.type,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((editableData.value.type) = $event)),
                      lookupSource: _unref(LookupTableSource).PropertyTypes
                    }, null, 8, ["modelValue", "lookupSource"]),
                    _createVNode(CurrencyInput, {
                      label: "Price",
                      modelValue: editableData.value.price,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((editableData.value.price) = $event)),
                      "max-value": 9999999999
                    }, null, 8, ["modelValue"]),
                    (editableData.value.category == _unref(PropertyCategory).ToLet)
                      ? (_openBlock(), _createBlock(SystemCodeSingleSelect, {
                          key: 1,
                          label: "Frequency",
                          modelValue: editableData.value.priceFrequency,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((editableData.value.priceFrequency) = $event)),
                          "code-type": _unref(CodeType).PropertyPriceFrequency
                        }, null, 8, ["modelValue", "code-type"]))
                      : _createCommentVNode("", true),
                    _createVNode(BedroomsSelect, {
                      label: "Bedrooms",
                      modelValue: editableData.value.bedrooms,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((editableData.value.bedrooms) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              }, 8, ["selected-index", "data-source"]))
            : _createCommentVNode("", true),
          _createElementVNode("section", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", {
                class: _normalizeClass({ hideButton: selectedIndex.value == 0 })
              }, [
                _createVNode(_unref(DxButton), {
                  text: "Back",
                  onClick: _cache[12] || (_cache[12] = (e) => onNavigateClick(0, e)),
                  icon: "spinleft",
                  disabled: saving.value
                }, null, 8, ["disabled"])
              ], 2),
              _createElementVNode("span", _hoisted_8, _toDisplayString(pageNumber.value) + " of 3", 1),
              _createVNode(_unref(DxButton), {
                text: nextSubmitButtonText.value,
                onClick: _cache[13] || (_cache[13] = (e) => onNavigateClick(1, e)),
                icon: "spinright",
                rtlEnabled: true,
                validationGroup: buttonValidationGroup.value,
                disabled: saving.value
              }, null, 8, ["text", "validationGroup", "disabled"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "showCloseConfirmationPrompt"]),
    _createVNode(ContactModal, {
      modelValue: displayNewContactModal.value,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((displayNewContactModal).value = $event)),
      onContactCreated: newContactCreated,
      isOwner: true,
      showAddPropertyPrompt: false
    }, null, 8, ["modelValue"]),
    (editableData.value)
      ? (_openBlock(), _createBlock(SelectCompanyModal, {
          key: 0,
          modelValue: displayCompaniesModal.value,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((displayCompaniesModal).value = $event)),
          propertyCategory: editableData.value.category,
          onCompanySelected: companySelected,
          companies: companies.value
        }, null, 8, ["modelValue", "propertyCategory", "companies"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})